import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { renderItem } from "./renderItem";

function Breaks({ data }) {
    const { t } = useTranslation();

    const { automatic, manual, rest } = useMemo(
        () => ({
            automatic: data?.automatic,
            manual: data?.manual,
            rest: data?.rest
        }),
        [data]
    );

    return (
        <>
            {automatic && (
                <>
                    <div className="tooltip-content-style">
                    <h4 className="mb-3 text-left" style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}>{t("automatic-break")}</h4>
                        {automatic?.status && renderItem(automatic.status, "status", t)}
                        {automatic?.breaks && renderItem(automatic.breaks, "breaks", t)}
                        {automatic?.hideBreakAndDeductTotal &&
                            renderItem(automatic.hideBreakAndDeductTotal, "hide-break-and-deduct-total", t)}
                        {automatic?.payCode && renderItem(automatic.payCode, "pay-code", t)}
                    </div>
                </>
            )}

            {manual && (
                <>
                    <div className="tooltip-content-style">
                    <h4 className="mb-3 text-left" style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}>{t("manual-break")}</h4>
                        {manual?.status && renderItem(manual.status, "status", t)}
                        {manual?.payCode && renderItem(manual.payCode, "pay-code", t)}
                        {manual?.mandatory && renderItem(manual.mandatory, "mandatory", t)}
                        {manual?.duration && renderItem(manual.duration, "duration", t)}
                    </div>
                </>
            )}

            {rest && (
                <>
                    <div className="tooltip-content-style">
                    <h4 className="mb-3 text-left" style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}>{t("rest-break")}</h4>
                        {rest?.status && renderItem(rest.status, "status", t)}
                        {rest?.breaks && renderItem(rest.breaks, "breaks", t)}
                    </div>
                </>
            )}
        </>
    );
}

export default Breaks;
